<template>
  <div class="mb-5">
    <b-container class="p-relative">
      <div class="header-text-container">
        <div class="header-text">My Account</div>
      </div>
    </b-container>

    <div class="cover-image">
      <div class="cover-overlay"></div>
    </div>

    <b-container>
      <change-email-form v-if="currentRoute === 'email'" />
      <change-password-form v-else-if="currentRoute === 'password'" />
    </b-container>
  </div>
</template>

<script>
import ChangeEmailForm from '@/components/forms/ChangeEmailForm'
import ChangePasswordForm from '@/components/forms/ChangePasswordForm'

export default {
  components: {
    ChangeEmailForm,
    ChangePasswordForm
  },

  computed: {
    currentRoute() {
      return this.$route.params.field
    }
  },

  created() {
    if (!this.$route.params.field) {
      this.$router.replace({
        name: 'user.settings-page',
        params: { tab: 3 }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-text-container {
  position: absolute;
  color: white;
  top: 95px;
  z-index: 2;
}
.header-text {
  font-size: 24px;
  font-weight: bold;
}
.cover-image {
  width: 100%;
  min-height: 160px;
  background: url('~@/assets/images/cover.jpeg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.9;
}
.cover-overlay {
  width: 100%;
  min-height: 160px;
  background-blend-mode: multiply;
  background: transparent url('~@/assets/images/overlay.svg') 0% 0% no-repeat
    padding-box;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
